import { render, staticRenderFns } from "./RecordView.vue?vue&type=template&id=16c0df19&scoped=true&"
import script from "./RecordView.vue?vue&type=script&lang=ts&"
export * from "./RecordView.vue?vue&type=script&lang=ts&"
import style0 from "./RecordView.vue?vue&type=style&index=0&id=16c0df19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0df19",
  null
  
)

export default component.exports